<template>
  <div class="container-block">
    <router-view name="mainheader"></router-view>
    <router-view name="main"></router-view>
    <Footer></Footer>
  </div>
</template>


<script>
export default {
};
</script>

<style lang="scss">
@import "./assets/scss/layout.scss";
</style>